export const R = {
	"ChildTermsTitle": "Jeg bekræfter hermed, at:",
	"ChildTermsBullet1": "jeg informerer andre med forældremyndighed over barnet om oprettelsen af barnets profil.",
	"ChildTermsBullet2": "jeg er informeret om, at &lt;a href=\"https://app.hejdoktor.dk/privatlivspolitik\" target=\"_blank\" class=\"underline\"&gt;Hejdoktors privatlivspolitik&lt;/a&gt; også gælder mit barn",
	"AdolescentTerms": "Jeg bekræfter hermed, at jeg informerer andre med forældremyndighed over den unge om oprettelsen af den unges profil."
}